import Debouncer from "./Debouncer";

const setScrollBarWidthDebouncer = new Debouncer(() => {
    document.documentElement.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.clientWidth) + "px");
});

window.addEventListener("resize", setScrollBarWidthDebouncer.run);
setScrollBarWidthDebouncer.runNow();
